import React from "react";
import { useParams, Link } from "react-router-dom";
import { Instagram, Spotify, Soundcloud, Twitter, Tiktok, ArrowLeft, AppleMusic } from "../constants/icons";
import { artistsdata } from "../data/artistdata";

const ArtistInfo = () => {
  const { web } = useParams();
  const artist = artistsdata.find((artist) => artist.web === web);

  if (!artist) {
    return <p>Artist not found.</p>;
  }

  return (
    <section className="artistinfo">
      <div className="artistinfobox">
        <Link to="/artists/#artistlist" className="arrow-left">
          <ArrowLeft className="ico" />
        </Link>
        <div className="artist-intro-desktop">
          <div className="imagebox">
            <img src={artist.image} alt={artist.name} />
          </div>
          <div className="textimg">
            <div className="infobox">
              <div className="name-socials">
                <h3>{artist.name}</h3>
                <div className="artist-media-links">
                  {/* <span className="prompt">Follow {artist.name}</span> */}
                  {artist.apple && (
                    <Link to={artist.apple}>
                      <AppleMusic className="artist-info-icons" />
                    </Link>
                  )}
                  {artist.spotify && (
                    <Link to={artist.spotify}>
                      <Spotify className="artist-info-icons" />
                    </Link>
                  )}
                  {artist.soundcloud && (
                    <Link to={artist.soundcloud}>
                      <Soundcloud className="artist-info-icons" />
                    </Link>
                  )}
                  {artist.instagram && (
                    <Link to={artist.instagram}>
                      <Instagram className="artist-info-icons" />
                    </Link>
                  )}
                  {artist.tiktok && (
                    <Link to={artist.tiktok}>
                      <Tiktok className="artist-info-icons" />
                    </Link>
                  )}
                  {artist.twitter && (
                    <Link to={artist.twitter}>
                      <Twitter className="artist-info-icons" />
                    </Link>
                  )}
                </div>
              </div>
              <p>{artist.description}</p>
            </div>
          </div>
        </div>
        <div className="artist-intro-tablet">
          <div className="artist-person">
            <div className="imagebox">
              <img src={artist.image} alt={artist.name} />
            </div>
            <div className="name-socials">
              <h3>{artist.name}</h3>
              <div className="artist-media-links">
                {/* <span className="prompt">Follow {artist.name}</span> */}
                {artist.apple && (
                  <Link to={artist.apple}>
                    <AppleMusic className="artist-info-icons" />
                  </Link>
                )}
                {artist.spotify && (
                  <Link to={artist.spotify}>
                    <Spotify className="artist-info-icons" />
                  </Link>
                )}
                {artist.soundcloud && (
                  <Link to={artist.soundcloud}>
                    <Soundcloud className="artist-info-icons" />
                  </Link>
                )}
                {artist.instagram && (
                  <Link to={artist.instagram}>
                    <Instagram className="artist-info-icons" />
                  </Link>
                )}
                {artist.tiktok && (
                  <Link to={artist.tiktok}>
                    <Tiktok className="artist-info-icons" />
                  </Link>
                )}
                {artist.twitter && (
                  <Link to={artist.twitter}>
                    <Twitter className="artist-info-icons" />
                  </Link>
                )}
              </div>
            </div>
          </div>
          <p>{artist.description}</p>
        </div>
        {artist.column1 && artist.column2 && artist.column3 && (
          <>
            <div className="other-links"></div>
          </>
        )}
      </div>
      {artist.interview_title &&
        artist.interview_img &&
        artist.interview_para1 &&
        artist.interview_para2 && (
          <div className="artist-interview" id="artist-itvw">
            <h3>{artist.interview_title}</h3>
            <div className="img-and-para1">
              <div className="img-cont">
                <img src={artist.interview_img} alt="" />
              </div>
              <div className="para1">
                <p>{artist.interview_para1}</p>
              </div>
            </div>
            <div className="para2">
              <p>{artist.interview_para2}</p>
            </div>
          </div>
        )}
    </section>
  );
};

export default ArtistInfo;
